import { render, staticRenderFns } from "./HeartVitalSvg.vue?vue&type=template&id=5a59028f&"
import script from "./HeartVitalSvg.vue?vue&type=script&lang=ts&"
export * from "./HeartVitalSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports